import { Buyer } from '@40seas/entities/buyers';
import { Partial } from '@40seas/entities/common';

export class UpdateBuyerDto extends Partial(Buyer) {}
